import { all, put } from 'redux-saga/effects';
import parseError from '@karma/utils/functions/parseError';
import { showErrorAlert } from '../actions';

function* handleServerError(error) {
  yield all(parseError(error.payload).map(message => put(showErrorAlert({ message }))));
}

export default handleServerError;
